// TODO: Hacked in a hidden field to get model-select's selected value 

import { ModelSelect } from 'vue-search-select';

if (document.getElementById('customer-select')) {
  const customers = document.getElementById('customer-select').dataset.customers;
  const lines = document.getElementById('customer-select').dataset.lines;

  var app = new Vue({
    el: '#customer-select',
    template: `
    <div>
      <model-select :options="customers" v-model="selected" name="fields[customerId]" placeholder="Select a customer" />
      <input type="hidden" name="fields[customerId]" :value="selected">

      <div style="width: 100%; text-align: center; font-weight: bold; color: #d10000;" v-show="isDuplicate">Note: This may be a duplicate order.</div>

      <div class="actions">
        <button class="btn md centered" type="submit" :disabled="selected.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="sm-icon">
            <path fill="#fff"
              d="M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64zM208 472c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm256 0c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm23.438-200H184.98l-31.31-160h368.548l-34.78 160z">
            </path>
          </svg>
          Place order
        </button>
      </div>
    </div>
    `,
    data(){
      return {
        customers: JSON.parse(customers),
        lines: JSON.parse(lines),
        selected: '',
        isDuplicate: false
      };
    },
    created() {
      window.vue = this;
    },
    mounted() {
    },
    watch: {
      selected: function(val, oldVal) {
        var data = {
          lines: lines,
          customerId: val
        };
        
        axios.post('/actions/ariq-module/send/precheck', data).then((res) => {
          if (res.data.hasMatch) {
            this.isDuplicate = true;
          } else {
            this.isDuplicate = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      }
    },
    components: {
      ModelSelect
    },
  });
}